import { render, staticRenderFns } from "./block-cars.vue?vue&type=template&id=3a5d1793&scoped=true"
import script from "./block-cars.vue?vue&type=script&lang=js"
export * from "./block-cars.vue?vue&type=script&lang=js"
import style0 from "./block-cars.vue?vue&type=style&index=0&id=3a5d1793&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d1793",
  null
  
)

export default component.exports